var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMir(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-91.000000, -154.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(91.000000, 154.000000)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#37A72E",
    d: "M72.151,48.6346v15.5225h8.6236v-9.1985 h9.7734c4.1134-0.0305,7.6076-2.6581,8.9252-6.324H72.151z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Combined-Shape_00000134216687258429162830000003382853316872010943_",
    gradientUnits: "userSpaceOnUse",
    x1: -630.8464,
    y1: 429.7529,
    x2: -630.7026,
    y2: 429.7529,
    gradientTransform: "matrix(201.7633 0 0 -79 127352.6484 33992)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A0E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0077C3"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape_00000081632337349337868570000005257744940271391111_",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#Combined-Shape_00000134216687258429162830000003382853316872010943_)",
    d: " M71.0012,35.8429c0.5023,6.3447,6.5048,11.3544,13.8356,11.3544c0.024,0,14.9947,0,14.9947,0 C99.9421,46.6154,100,46.0148,100,45.4007c0-5.2558-4.2404-9.519-9.486-9.5576L71.0012,35.8429z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape_00000155122116052347318290000006865053981313415064_",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#37A72E",
    d: " M58.2382,47.0463l0.0068-0.0145l0.0009,0.0002c0.0884-0.1586,0.2578-0.2659,0.4523-0.2659c0.2809,0,0.5096,0.2239,0.5172,0.503 l0.0002,0v16.7442h8.6236V35.8429h-8.6236c-1.0936,0.0364-2.3291,0.8389-2.7885,1.8239L49.5643,52.384 c-0.017,0.0602-0.0434,0.1163-0.0778,0.1667l-0.0023,0.0049l-0.0009-0.0003c-0.1038,0.1494-0.2767,0.2473-0.4725,0.2473 c-0.3175,0-0.5749-0.2574-0.5749-0.5749V35.8429h-8.6236v28.1705h8.6236v-0.0032c1.0816-0.0565,2.2881-0.8499,2.7408-1.8207 l7.0437-15.1052C58.2259,47.0714,58.2318,47.0587,58.2382,47.0463L58.2382,47.0463z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape_00000008869887954876756520000001422960430755751094_",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#37A72E",
    d: " M26.0366,47.5279l-5.0401,16.4855h-6.2036L9.7497,47.5179c-0.0486-0.2641-0.2801-0.4643-0.5583-0.4643 c-0.3135,0-0.5677,0.2542-0.5677,0.5677c0,0.0024,0,0.0048,0,0.0072l0,16.3849H0V35.8429h7.4019h2.2044 c1.5868,0,3.2496,1.2314,3.7133,2.7481l4.1969,13.7274c0.2088,0.683,0.5476,0.6823,0.7562,0l4.1969-13.7274 c0.464-1.5177,2.1263-2.7481,3.7133-2.7481h2.2038h7.4013v28.1705h-8.6236V47.6285c0-0.0024,0-0.0048,0-0.0072 c0-0.3135-0.2542-0.5677-0.5677-0.5677C26.315,47.0536,26.0812,47.2588,26.0366,47.5279L26.0366,47.5279z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMir);
export default __webpack_public_path__ + "static/media/mir.cfe1e303.svg";
export { ForwardRef as ReactComponent };